import { createRouter, createWebHistory } from 'vue-router'
import { SITE_NAME } from '@/constants/site'
import HelloWorld from '../components/HelloWorld.vue'
import Register from '../pages/Register.vue'
import CheckInbox from '../pages/CheckInbox.vue'
import SignIn from '../pages/SignIn.vue'
import FortgotPassword from '../pages/ForgotPassword.vue'
import ResetPassword from '../pages/ResetPassword.vue'
import ResetSuccess from '../pages/ResetSuccess.vue'
import Successed from '../pages/Successed.vue'
import Home from '../pages/Home.vue'
import Allcourses from '@/pages/Allcourses.vue'

import CourseDetail from '@/pages/CourseDetail.vue'
import Dashboard from '@/pages/Dashboard.vue'
import FavoriteList from '@/pages/FavoriteList.vue'

import FAQpage from '@/pages/FAQpage.vue'
import ProfileEdit from '@/pages/ProfileEdit.vue'
import Security from '@/pages/Security.vue';
import Privacy from '@/pages/Privacy.vue';
import Terms from '@/pages/Terms.vue';
import Planorigin from '@/pages/Planorigin.vue';

import RegisterProfile from '@/pages/RegisterProfile.vue';


import Emailvalidate from '@/pages/Emailvalidate.vue';
import Certificate from '@/pages/Certificate.vue';
import VerifyEmail from '@/pages/verify-email.vue';
import PhoneValidate from '@/pages/PhoneValidate.vue';
import BindMobile from '@/pages/BindMobile.vue';

import DirectorIntro from '@/pages/Director-intro.vue';
import MinisterIntro from '@/pages/Minister-intro.vue';
import CustomerService from '@/pages/CustomerService.vue';
import ExpertDirectory from '@/pages/ExpertDirectory.vue';
import ViceMinisterIntro from '@/pages/ViceMinister-intro.vue';
import SnomedCT from '@/pages/SnomedCT.vue';
import SnomedCTEducation from '@/pages/SnomedCTEducation.vue';
import Activities from '../pages/Activities.vue';
import ActivitiesDetail from '../pages/ActivitiesDetail.vue';
import WorkshopMaterials from '@/pages/Workshop-materials.vue';
import StandardAnnouncements from '@/pages/Standard-announcements.vue';
import CertificationApply from '@/pages/Certification-apply.vue';
import AdditionalTerms from '@/pages/AdditionalTerms.vue';
import Sitemap from '@/pages/Sitemap.vue';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/sitemap', name: 'Sitemap', component: Sitemap },
  { path: '/Sitemap', redirect: '/sitemap' },
  { path: '/activities', name: 'Activities', component: Activities },
  { path: '/activities/:id', name: 'ActivitiesDetail', component: ActivitiesDetail },
  { path: '/workshop-materials', name: 'WorkshopMaterials', component: WorkshopMaterials },
  { path: '/certification-apply', name: 'CertificationApply', component: CertificationApply },
  { path: '/standard-announcements', name: 'StandardAnnouncements', component: StandardAnnouncements },
  { path: '/home', name: '首頁', component: Home },
  { path: '/forgot-password', name: 'About', component: FortgotPassword },

  { path: '/register', name: 'Register', component: Register },
  { path: '/sign-in', name: '登入', component: SignIn },
  { path: '/workshop-courses', name: 'Allcourses', component: Allcourses },

  { path: '/course/:id', name: 'course-detail', component: CourseDetail },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/Dashboard', redirect: '/dashboard' },
  { path: '/favorites', name: 'FavoriteList', component: FavoriteList, meta: { requiresAuth: true } },
  { path: '/FavoriteList', redirect: '/favorites' },

  // { path: '/FAQpage', name: 'FAQpage', component: FAQpage },
  { path: '/ProfileEdit', name: 'ProfileEdit', component: ProfileEdit },
  { path: '/register-profile', name: 'RegisterProfile', component: RegisterProfile },
  { path: '/privacy', name: 'Privacy', component: Privacy },
  { path: '/Privacy', redirect: '/privacy' },
  { path: '/terms', name: 'Terms', component: Privacy },
  { path: '/Terms', redirect: '/privacy' },
  { path: '/security', redirect: '/privacy' },
  { path: '/Security', redirect: '/privacy' },
  { path: '/additional-terms', name: 'AdditionalTerms', component: AdditionalTerms },
  // { path: '/Planorigin', name: 'Planorigin', component: Planorigin },
  { path: '/director-intro', name: 'DirectorIntro', component: DirectorIntro },
  { path: '/minister-intro', name: 'MinisterIntro', component: MinisterIntro },
  { path: '/vice-minister-intro', name: 'ViceMinisterIntro', component: ViceMinisterIntro },
  { path: '/snomed-ct', name: 'SnomedCT', component: SnomedCT },
  { path: '/snomed-ct-education', name: 'SnomedCTEducation', component: SnomedCTEducation },


  { path: '/Emailvalidate', name: 'Emailvalidate', component: Emailvalidate },
  { path: '/Certificate', name: 'Certificate', component: Certificate, meta: { requiresAuth: true, requiresAdditionalTerms: true } },
  { path: '/verify-email', name: 'verify-email', component: VerifyEmail },
  { path: '/phone-validate', name: 'PhoneValidate', component: PhoneValidate },
  { path: '/bind-mobile', name: 'BindMobile', component: BindMobile, meta: { requiresAuth: true } },
  { path: '/customer-service', name: 'CustomerService', component: CustomerService },
  { path: '/expert-directory', name: 'ExpertDirectory', component: ExpertDirectory },
  { path: '/reset-password', name: '重設密碼', component: ResetPassword },
  { path: '/check-email', name: '查看收件匣', component: CheckInbox },
  { path: '/reset-success', name: '重設完成', component: ResetSuccess },
  { path: '/successed', name: '完成註冊', component: Successed },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('ms_platform_token');
  const isAuthenticated = !!token;

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdditionalTerms = to.matched.some(record => record.meta.requiresAdditionalTerms);

  // 定義不需要記錄的路徑
  const excludedPaths = [
    '/forgot-password',
    '/register',
    '/register-profile',
    '/sign-in',
    '/verify-email',
    '/emailvalidate',
    '/reset-password',
    '/check-email',
    '/reset-success',
    '/successed',
    '/additional-terms'
  ];

  // 檢查當前路徑是否需要記錄（排除指定路徑和 steps 的子路徑）
  const shouldrecordpath = !excludedPaths.includes(to.path.toLowerCase());

  // 如果需要記錄路徑，則保存到 session storage
  if (shouldrecordpath) {
    localStorage.setItem('lastVisitedPath', to.path);
  }

  if (requiresAuth && !isAuthenticated) {
    next({ path: '/sign-in', query: { redirect: to.fullPath } });
    return;
  }

  if (requiresAdditionalTerms && isAuthenticated) {
    try {
      const rawUser = localStorage.getItem('user_data');
      const user = rawUser ? JSON.parse(rawUser) : null;
      const isAgreed = user?.standards_terms_agreed ? user.standards_terms_agreed['snomed_ct'] : user?.additional_terms_agreed;
      if (!isAgreed) {
        next({ path: '/additional-terms', query: { redirect: to.fullPath } });
        return;
      }
    } catch (e) {
      console.error('Check additional terms error:', e);
    }
  }

  next();
})

// 依照頁面不同動態改變瀏覽器標題 (將頁面 banner-title 作為標題)
router.afterEach((to) => {
  const fullSiteTitle = `${SITE_NAME} - 數位健康標準推廣平台`;

  if (to.path === '/' || to.path === '/home') {
    document.title = `首頁 | ${fullSiteTitle}`;
    return;
  }

  // 稍作延遲確保組件已掛載渲染出 banner-title
  setTimeout(() => {
    const bannerEl = document.querySelector('.banner-title, .page-title, .activities-title, h1');
    const titleText = bannerEl?.textContent?.trim();

    if (titleText) {
      document.title = `${titleText} | ${fullSiteTitle}`;
    } else if (to.name && typeof to.name === 'string' && !['About', 'Home'].includes(to.name)) {
      document.title = `${to.name} | ${fullSiteTitle}`;
    } else {
      document.title = fullSiteTitle;
    }
  }, 120);
})

export default router
